import styled from 'styled-components';

import { appColors } from '../../config/colors';

export const TestCommentsWrapper = styled.div`
  display: block;
  width: 100%;
  padding: 2em;
  margin-top: 2em;
  margin-bottom: 4em;
  border: 0.1px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
  background-color: ${appColors.backgroundSecondary}; ;
`;

export const TestCommentsForm = styled.form``;

export const TestCommentsTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 1em;
  font-size: 1rem;
  padding: 0.5em;
  border: 1px solid ${appColors.border};
  border-left: 3px solid ${appColors.outline};
  resize: vertical;
`;

export const TestCommentsButton = styled.input`
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.5em;
  margin-left: auto;
  color: ${appColors.buttonFont};
  background-color: ${appColors.buttonBackground};
  border-top: 2px solid ${appColors.border};
  border-right: 2px solid ${appColors.shadow};
  border-bottom: 2px solid ${appColors.shadow};
  border-left: 2px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
`;

export const TestCommentsResponseWrapper = styled.div`
  display: flex;
`;

export const TestCommentsResponse = styled.div<{ type?: string }>`
  color: white;
  border-radius: 0.25em;
  padding: 0.5em;
  font-size: 0.75em;
  margin-right: 2em;
  background-color: ${({ type }) =>
    type === 'mention' ? appColors.tagSuccess : appColors.tagNeutral};
`;
